import { cn } from "@/lib/utils";
import { DemoMaskedText } from "@/components/demo/DemoMaskedText";


export function ForReferenceOnly({
  className = '',
}: { className?: string }) {
  return (
    <span className={
      cn(
        "text-2xs text-annotation-foreground",
        className,
      )
    }>
      <DemoMaskedText>内容由 AI 生成，仅供参考</DemoMaskedText>
    </span>
  )
}
